import React from 'react'

import { EllipseIcon } from '@guiker/icons'

export const ActivityMarker: React.FC = () => {
  return <EllipseIcon size={6} color={30} />
}
